module.exports = __webpack_public_path__ + "r-v3/img/ico_music_off_white.4ceb96e3.svg";